var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AccountantsSubmenu',{class:{ horizontal: _vm.horizontal },attrs:{"items":_vm.menuItems,"route-params":{ customerId: _vm.getCompanyId }},scopedSlots:_vm._u([{key:"titletop",fn:function(){return undefined},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }